export interface IClockInOutResData {
    id: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    staffType: string;
    createdDate: string;
    birthday: string;
    staffSalaryType: string;
    status: string;
    urlImage: string;
    password: string;
    anyBody: boolean;
}



export interface IHistoryClockInOutResData {
    content: IHistoryClockInOutContentItem[];
    pageable: Pageable;
    last: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    first: boolean;
    numberOfElements: number;
    empty: boolean;
}

export interface IHistoryClockInOutContentItem {
    staffName: string;
    avatar: null;
    time: string;
    type: Type;
}

export enum StaffName {
    HaleyAdams = 'Haley Adams',
    SofiaYoung = 'Sofia Young',
}

export enum Type {
    ClockIn = 'CLOCK_IN',
    ClockOut = 'CLOCK_OUT',
}

export interface Pageable {
    pageNumber: number;
    pageSize: number;
    offset: number;
    unpaged: boolean;
    paged: boolean;
}

export enum ICheckInType {
    APPOINTMENT = 'APPOINTMENT',
    WALK_IN = 'WALK_IN',
}
export interface IHistoryCheckInResData {
    id?: string;
    ticketNumber: number;
    checkInTime: string; // format: MM-DD-YYYY hh:mmA
    customerName: string;
    customerPhone: string;
    type: ICheckInType;
    stationNumber: string | null;
}

export interface IHistoryCheckInSummaryResData {
    totalCheckIn: number;
    totalWalkIn: number;
    totalAppointment: number;
}